import React from 'react';
import { PaginationProps } from './types';

import './Pagination.scss';

export const Pagination: React.FC<PaginationProps> = ({
  pages,
  activePage,
  onClick,
}) => {
  const getClickHandler = (page: number) => () => onClick(page);
  return (
    <div className="pagination">
      {Array.from({ length: pages }, (_, i) => i).map((i) => (
        <span
          key={i}
          title={`${i}`}
          className={`pagination-dot ${activePage === i ? 'active' : ''}`}
          onClick={getClickHandler(i)}
        />
      ))}
    </div>
  );
};
